export default __webpack_public_path__ + "static/media/gallery-wip-cover_04.92a02fac.jpg";